import { RawFile } from "@mapmycustomers/shared/types/File";

import hasMimeType, { DOCUMENT_PDF, IMAGE_ANY, VIDEO_ANY } from "@app/util/mimeType";

const canPreview = (file: RawFile) =>
  hasMimeType(file, [...IMAGE_ANY, ...VIDEO_ANY, ...DOCUMENT_PDF]);

export default canPreview;
